import { currencies } from 'lib';
import { store } from 'store';

/*
  Get cost with dynamic currencies,
  also returns currency symbol, converted cost and original cost
*/
function getCost(rates, currency, price, toCurrency) {
  const user = store.getState().user,
    currentUserCurrency = user?.billing?.currency?.toLowerCase() || 'usd',
    convertedCurrency = currencies.find(
      (x) => x.value.toLowerCase() === (toCurrency || currentUserCurrency).toLowerCase()
    ),
    originalCurrency = currencies.find(
      (x) => x.value.toLowerCase() === (currency || 'usd').toLowerCase()
    );

  const priceToUsd = price / Number(rates ? rates[currency.toLowerCase()] : 1),
    usdToUserPrice = priceToUsd * Number(rates ? rates[convertedCurrency.value.toLowerCase()] : 1);

  const data = {
    originalPrice: price || 0,
    originalCurrency,
    convertedPrice: usdToUserPrice || 0,
    convertedCurrency
  };

  return data;
}

export default getCost;
